import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "mastofa_cookie_consent";

export function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (!stored) setShow(true);
  }, []);

  const decide = (choice) => {
    const value = {
      necessary: true,
      analytics: choice === "accept",
      marketing: choice === "accept",
      at: new Date().toISOString(),
      choice,
    };
    localStorage.setItem(KEY, JSON.stringify(value));
    window.__mastofaCookieConsent = value;
    window.dispatchEvent(new CustomEvent("mastofa:consent", { detail: value }));
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="cookie-banner" data-testid="cookie-consent">
      <div className="cookie-banner-inner">
        <div className="cookie-banner-icon"><Cookie size={22} /></div>
        <div className="cookie-banner-text">
          <b>Kami menggunakan cookies</b>
          <p>
            Cookies necessary untuk operasional (login, keranjang). Cookies analytics &
            marketing untuk mengukur performa iklan &amp; menyempurnakan pengalaman Anda.
            Baca <Link to="/cookie" className="text-link">Kebijakan Cookie</Link>.
          </p>
        </div>
        <div className="cookie-banner-actions">
          <button className="button button-small" onClick={() => decide("accept")}
                  data-testid="cookie-accept">Terima semua</button>
          <button className="button-ghost button-small" onClick={() => decide("reject")}
                  data-testid="cookie-reject">Tolak</button>
          <button className="cookie-close" onClick={() => decide("necessary")}
                  aria-label="Tutup" data-testid="cookie-close"><X size={16} /></button>
        </div>
      </div>
    </div>
  );
}

export function getConsent() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}

export function hasAnalyticsConsent() {
  const c = getConsent();
  return !!(c && c.analytics);
}
